import {MatchStatus} from "../pages/custom-components/MatchBoard/MatchCard";

export type SupportedSports = 'basketball' | 'football' | 'volley' | 'tennis';
export const defaultFadeDuration = 0.3
export const minAudioFadeDuration = 0.2
export const maxAudioFadeDuration = 0.5
export const defaultOpenerCloserObject = {
    id: "",
    name: "",
    type: "",
    thumbnail_url: "",
    video_url: "",
    multi_event: false,
};

export const FootballEventsOfInterest = [
    {
        key_moment: "SCENE_PLAYERS_ENTERING_PITCH",
        start: 'auto',
        end: 'auto',
        included: false,
    },
    {
        key_moment: "SCENE_ANTHEM_LINEUP",
        start: 'auto',
        end: 'auto',
        included: false,
    },
    {
        key_moment: "SCENE_COIN_TOSS",
        start: 'auto',
        end: 'auto',
        included: false,
    },
    {
        key_moment: "SCENE_KICKOFF_SETUP",
        start: 'auto',
        end: 'auto',
        included: false,
    },
    {
        key_moment: "SCENE_INTERVIEW",
        start: 'auto',
        end: 'auto',
        included: false,
    },
    {
        key_moment: "SCENE_PLAYERS_GREETINGS",
        start: 'auto',
        end: 'auto',
        included: false,
    },
    {
        key_moment: "START",
        start: 'auto',
        end: 'auto',
        included: true,
    },
    {
        key_moment: "GOAL",
        start: 'auto',
        end: 'auto',
        included: true,
        replay: true,
        var: true,
    },
    {
        key_moment: "SAVE",
        start: 'auto',
        end: 'auto',
        included: true,
    },
    {
        key_moment: "MISS",
        start: 'auto',
        end: 'auto',
        included: true,
    },
    {
        key_moment: "CARD",
        start: 'auto',
        end: 'auto',
        included: true,
        var: true,
    },
    {
        key_moment: "END",
        start: 'auto',
        end: 'auto',
        included: true,
    },
]

export const FootballSkills = [
    //{ key_moment: 'SKILL_PASS',       start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_TACKLE',     start: 'auto', end: 'auto', included: false },
    //{ key_moment: 'SKILL_SAVE',       start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_SHOT',       start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_CROSS',      start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_DRIBBLING',  start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_GOOD_SKILL', start: 'auto', end: 'auto', included: false },
    //{ key_moment: 'SKILL_GOAL',       start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_ASSIST',     start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_HEAD',       start: 'auto', end: 'auto', included: false },
    { key_moment: 'SKILL_SET_PIECE',  start: 'auto', end: 'auto', included: false },
    //{ key_moment: 'SKILL_GOAL_FRAME', start: 'auto', end: 'auto', included: false },
]

export const BasketBallEventsOfInterest = [
    { key_moment: "START",        start: 'auto', end: 'auto', included: true },
    { key_moment: "THREE_POINTS", start: 'auto', end: 'auto', included: true },
    { key_moment: "BLOCK",        start: 'auto', end: 'auto', included: true },
    { key_moment: "FREETHROW",    start: 'auto', end: 'auto', included: true },
    { key_moment: "TWO_POINTS",   start: 'auto', end: 'auto', included: true },
    { key_moment: "DUNK",         start: 'auto', end: 'auto', included: true },
    { key_moment: "END",          start: 'auto', end: 'auto', included: true },
]

export const VolleyBallEventsOfInterest = [
    { key_moment: "RALLY_POINT", start: 'auto', end: 'auto', included: true },
    { key_moment: "SET_POINT",        start: 'auto', end: 'auto', included: true },
    { key_moment: "MATCH_POINT",    start: 'auto', end: 'auto', included: true },
]

const basketballHighlightSettings = [
    {
        type: 'Regular',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: minAudioFadeDuration
    },
    {
        type: 'Fast',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        music: {
            filename: '',
            src: '',
            label: ''
        }
    },
    {
        type: 'Pistolero',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: minAudioFadeDuration
    }
]

const footballHighlightSettings = [
    {
        type: 'Regular',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: defaultFadeDuration
    },
]

const SettingSportDict = {
    eventOfInterest:{
        football: FootballEventsOfInterest,
        basketball: BasketBallEventsOfInterest,
        volley: VolleyBallEventsOfInterest,
        tennis: [],
    },
    skills: {
        football: FootballSkills,
        basketball: [],
        volley: [],
        tennis: []
    }
}

const HighlightSettingsDict = {
    football: footballHighlightSettings,
    basketball: basketballHighlightSettings
}

export function getDefaultDataJob(sportLabel: string) {
    const sport = sportLabel as SupportedSports;
    return {
        name: "",
        description: "",
        extraction_schedule: new Date(),
        job_base_folder: "",
        llm_generation: true,
        tag: [],
        target: "clipping",
        push_schedule: null,
        settings: {
            events_of_interest: SettingSportDict.eventOfInterest[sport],
            offset: 5,
            skills: SettingSportDict.skills[sport]
        },
        highlights_settings: [],
        data_sources: [],
        tracks: [],
        events: {
            id: ""
        },
        hooks: [],
        kafka_hook: false,
    }
}

export const getMatchStatusFromJobs = (jobs: any[], matchId: string): MatchStatus => {
    if (!jobs || jobs.length === 0) return 'SCHEDULABLE';

    const matchingJobs = jobs.filter(
        (job) => job.type === 'ingestion' && job.events?.some((e: any) => e.id === matchId)
    );

    if (matchingJobs.length === 0) return 'SCHEDULABLE';

    const isRunning = matchingJobs.some(
        (job) => job.status?.toLowerCase() === 'running'
    );
    if (isRunning) return 'LIVE';

    const isCompleted = matchingJobs.some(
        (job) => job.status?.toLowerCase() === 'completed'
    );
    if (isCompleted) return 'COMPLETED';

    return 'SCHEDULABLE';
};